<!--
  Contenido del modal de información de una plantilla: resumen legible de su configuración
  (modo de grupos, imágenes, curva S, columnas de tabla, disciplinas, Gantt). Las columnas y
  líneas se muestran con el nombre real del informe (en inglés). Datos desde template.info.
-->
<template>
  <div class="ti">
    <p class="ti-lead">{{ template.desc }}</p>

    <dl class="ti-grid">
      <div v-if="info.groupMode" class="ti-row">
        <dt>{{ $t('group_progress') }}</dt>
        <dd><span class="ti-chip ti-chip--key">{{ info.groupMode === 'parent' ? $t('parent') : $t('children') }}</span></dd>
      </div>
      <p v-if="info.groupMode === 'children'" class="ti-note">
        <b-icon pack="fas" icon="circle-info" size="is-small" class="text-blue-500" />
        <span>{{ $t('dashboard_children_note') }}</span>
      </p>

      <div v-if="info.generalImages" class="ti-row">
        <dt>{{ $t('general_images') }}</dt><dd>{{ info.generalImages }}</dd>
      </div>
      <div v-if="info.disciplineImages" class="ti-row">
        <dt>{{ $t('discipline_images') }}</dt><dd>{{ info.disciplineImages }}</dd>
      </div>

      <div v-if="info.scurveLines && info.scurveLines.length" class="ti-row">
        <dt>{{ $t('s_curve') }}</dt>
        <dd><span v-for="(l, i) in info.scurveLines" :key="i" class="ti-chip">{{ l }}</span></dd>
      </div>

      <div v-if="info.taskColumns && info.taskColumns.length" class="ti-row">
        <dt>{{ $t('task_columns') }}</dt>
        <dd><span v-for="(c, i) in info.taskColumns" :key="i" class="ti-chip">{{ c }}</span></dd>
      </div>

      <div v-if="info.disciplines && info.disciplines.length" class="ti-row">
        <dt>{{ $t('sections_disciplines') }}</dt>
        <dd><span v-for="(d, i) in info.disciplines" :key="i" class="ti-chip ti-chip--key">{{ d }}</span></dd>
      </div>

      <div class="ti-row">
        <dt>Gantt</dt>
        <dd>
          <template v-if="info.gantt">{{ info.ganttImages ? (info.ganttImages + ' ' + $t('images')) : $t('yes') }}</template>
          <template v-else>{{ $t('no') }}</template>
        </dd>
      </div>
    </dl>

    <footer class="ti-foot">
      <b-button size="is-small" type="is-primary" class="ti-blue" @click="$emit('use')">{{ $t('view_template') }}</b-button>
      <b-button size="is-small" @click="$emit('close')">{{ $t('close') }}</b-button>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'template-info',
  props: {
    template: { type: Object, required: true },
  },
  computed: {
    info() { return this.template.info || {} },
  },
}
</script>

<style scoped>
.ti { display: flex; flex-direction: column; gap: 14px; }
.ti-lead { color: #697289; font-size: 13px; line-height: 1.5; margin: 0; }
.ti-grid { display: flex; flex-direction: column; gap: 10px; margin: 0; }
.ti-row { display: grid; grid-template-columns: 170px 1fr; gap: 12px; align-items: baseline; }
.ti-row dt { font-size: 11px; font-weight: 800; letter-spacing: .04em; text-transform: uppercase; color: #9aa3b5; margin: 0; }
.ti-row dd { margin: 0; display: flex; flex-wrap: wrap; gap: 5px; font-size: 13.5px; font-weight: 700; color: #16203a; }
.ti-chip { font-size: 11.5px; font-weight: 700; color: #697289; background: #f6f8fb; border: 1px solid #e2e7ef; border-radius: 999px; padding: 2px 9px; }
.ti-chip--key { color: #1b3d94; background: #e8eefc; border-color: #d7e1fb; }
.ti-note { display: flex; align-items: flex-start; gap: 7px; font-size: 12px; color: #697289; background: #f6f8fb; border: 1px solid #e2e7ef; border-radius: 10px; padding: 9px 11px; margin: 0; }
.ti-foot { display: flex; justify-content: flex-end; gap: 8px; border-top: 1px solid #e2e7ef; padding-top: 14px; }
.ti-foot .ti-blue { background: #2456d6; border-color: #2456d6; color: #fff; }
.ti-foot .ti-blue:hover { background: #1b3d94; border-color: #1b3d94; }

@media (max-width: 600px) { .ti-row { grid-template-columns: 1fr; gap: 4px; } }
</style>
